import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";

import { showLoadErrorPage } from "shared/boot/errors";
import { getLocaleText } from "shared/boot/i18n";
import applyThemeConfig from "shared/helpers/applyThemeConfig";
import { useInsightsDashboardStore } from "shared/modules/InsightsDashboard/stores/useInsightsDashboardStore";
import { type Uuid } from "shared/types";

export const INSIGHTS_DASHBOARD_CHART_ROUTE =
  "insights-dashboards-dashboard-chart";

export default applyThemeConfig([
  {
    component: () => import("src/pages/SharePage.vue"),
    name: "home",
    path: "/",
  },
  {
    children: [
      {
        children: [
          {
            component: () =>
              import("shared/modules/InsightsDashboard/pages/InsightsDashboardEdit/InsightsDashboardEdit.vue").catch(
                showLoadErrorPage
              ),
            name: "insights-dashboards-dashboard",
            path: "",
            props: (route) => ({
              id: route.params.id,
            }),
          },
          {
            component: () =>
              import("shared/modules/InsightsDashboard/pages/InsightsDashboardChartDetail/InsightsDashboardChartDetail.vue").catch(
                showLoadErrorPage
              ),
            meta: {
              hideInsightsSearch: true,
              title: (route: RouteLocationNormalized) => {
                const { getChartLabelByUuid } = useInsightsDashboardStore();

                return getChartLabelByUuid(route.params.uuid as Uuid);
              },
            },
            name: INSIGHTS_DASHBOARD_CHART_ROUTE,
            path: "chart/:uuid",
            props: (route) => ({
              id: route.params.id,
              uuid: route.params.uuid,
            }),
          },
        ],
        component: () =>
          import("shared/modules/InsightsDashboard/pages/InsightsDashboard/InsightsDashboard.vue"),
        meta: {
          hideInsightsSearch: true,
          title: () => {
            const { dashboard, isLoading } = useInsightsDashboardStore();

            if (isLoading) {
              return getLocaleText("global.loading");
            }

            if (dashboard?.name) {
              return dashboard.name;
            }

            return getLocaleText("routes.insights_dashboard");
          },
        },
        path: ":id",
        props: (route) => ({
          id: route.params.id,
        }),
      },
    ],
    component: () =>
      import("src/pages/SharedInsightsPage.vue").catch(showLoadErrorPage),
    meta: {
      hideHeader: true,
      hideMenu: true,
      hideSearchBar: true,
      routeKey: "insights",
    },
    name: "insights",
    path: "/insights",
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
] as RouteRecordRaw[]);
